import * as React from "react";
import {
  createMaterialTopTabNavigator,
  MaterialTopTabBar,
} from "@react-navigation/material-top-tabs";
import HomeHeader from "../components/headers/HomeHeader";

import CategoryScreen from "../screens/product/Category";
import ManufacturerScreen from "../screens/product/Manufacturer";
import { useFocusEffect } from "@react-navigation/native";
import FontStyles from "../constants/FontStyle";
import Colors from "../constants/Colors";
import AsyncStorage from "@react-native-async-storage/async-storage";
import HomeTopTabBar from "../components/common/HomeTopTabBar";

const Tab = createMaterialTopTabNavigator();

export default function () {
  const [vis, setVis] = React.useState({
    category: false,
    manufacturer: false,
  });

  const nav_tab_options: any = {
    labelStyle: {
      ...FontStyles.size14,
      ...FontStyles.lh16,
      ...FontStyles.medium,
      textAlign: "center",
      marginBottom: 8,
      textTransform: "capitalize",
    },
    activeTintColor: Colors.darkTextColor,
    indicatorStyle: {
      left: vis.category && vis.manufacturer ? "20%" : "40%",
      width: vis.category && vis.manufacturer ? "10%" : "20%",
      height: 3,
      alignSelf: "center",
      backgroundColor: Colors.darkTextColor,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
    },
    style: {
      backgroundColor: Colors.whiteColor,
      elevation: 0,
    },
  };

  useFocusEffect(
    React.useCallback(() => {
      (async function () {
        let isCategoryVisible = await AsyncStorage.getItem("categoryView");
        let isManufacturerVisible = await AsyncStorage.getItem(
          "manufacturerView"
        );

        setVis({
          category:
            isCategoryVisible && isCategoryVisible === "active" ? true : false,
          manufacturer:
            isManufacturerVisible && isManufacturerVisible === "active"
              ? true
              : false,
        });
      })();
      return () => {};
    }, [])
  );
  return (
    <>
      <HomeHeader />

      {vis.category && vis.manufacturer ? (
        <Tab.Navigator
          // tabBar={props => <MaterialTopTabBar {...props} />}
          tabBar={(props) => <HomeTopTabBar {...props} />}
          tabBarOptions={nav_tab_options}
        >
          <Tab.Screen
            name="Category"
            component={CategoryScreen}
            options={{
              title: "Categories - Suplias Now",
              tabBarLabel: "Categories",
            }}
          />
          <Tab.Screen
            name="Manufacturer"
            component={ManufacturerScreen}
            options={{
              title: "Manufacturers - Suplias Now",
              tabBarLabel: "Manufacturers",
            }}
          />
        </Tab.Navigator>
      ) : vis.category ? (
        <Tab.Navigator
          tabBar={(props) => <MaterialTopTabBar {...props} />}
          tabBarOptions={nav_tab_options}
        >
          <Tab.Screen
            name="Category"
            component={CategoryScreen}
            options={{
              title: "Categories - Suplias Now",
              tabBarLabel: "Categories",
            }}
          />
        </Tab.Navigator>
      ) : vis.manufacturer ? (
        <Tab.Navigator
          tabBar={(props) => <MaterialTopTabBar {...props} />}
          tabBarOptions={nav_tab_options}
        >
          <Tab.Screen
            name="Manufacturer"
            component={ManufacturerScreen}
            options={{
              title: "Manufacturers - Suplias Now",
              tabBarLabel: "Manufacturers",
            }}
          />
        </Tab.Navigator>
      ) : null}
    </>
  );
}
